import standardAPI from '@/api/standard_items';

const state = {
  agencies: [],
  agencies_status: '',
  agencies_MetaData: {},
  agencies_page: 1,
  agencies_perPage: 10,
};

const responseUrl = '/agencies';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_agencies ({ commit }, getOptions) {
    commit('AGENCIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('AGENCIES_SUCCESS', response);
            commit('AGENCIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('AGENCIES_READY');
            reject(response);
          } else {
            commit('AGENCIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_agency ({ commit, dispatch }, itemData) {
    commit('AGENCIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('AGENCIES_READY');
          resolve(response);
        } else {
          commit('AGENCIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_agency ({ commit, dispatch }, itemData) {
    commit('AGENCIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('AGENCIES_READY');
          resolve(response);
        } else {
          commit('AGENCIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_agency ({ commit, dispatch }, itemData) {
    commit('AGENCIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('AGENCIES_READY');
          resolve(response);
        } else {
          commit('AGENCIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_agency ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.agencies_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.agencies_perPage = max;
  },
  AGENCIES_READY: (state) => {
    state.agencies_status = 'ready';
  },
  AGENCIES_REQUEST: (state) => {
    state.agencies_status = 'loading';
  },
  AGENCIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.agencies_MetaData.meta = response.meta;
      state.agencies_MetaData.links = response.links;
    }
    state.agencies = response.data;
    state.agencies_status = 'success';
  },
  AGENCIES_ERROR: (state) => {
    state.agencies_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
